module.exports = __webpack_public_path__ + "static/media/vc_alt2.b1e8958a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/vc_alt2.jpg
// module id = 431
// module chunks = 0